import { useEffect } from 'react';

/**
 * Adjusts the position of the scroll-to-top button on the screen
 * @param shouldLift - Whether the scroll-to-top button should be lifted (moved up).
 *   Typically set to `true` when the bottom banner is visible and active.
 * @param selector - (Optional) CSS selector for the scroll-to-top button.
 *   Defaults to `button[class*="ScrollToTopButton"]`.
 */
export const useAdjustScrollButton = (
  shouldLift: boolean,
  selector: string = 'button[class*="ScrollToTopButton"]'
): void => {
  useEffect(() => {
    const scrollBtn = document.querySelector(selector) as HTMLElement | null;
    if (!scrollBtn) return;

    scrollBtn.style.bottom = shouldLift ? '95px' : '';
  }, [shouldLift, selector]);
};
